import { INavigationsConstants } from '@common-modules/shared/constants/navigation-constants';
import { WlmNavKeys } from '@water-loss/features/navigation/wlm-nav-keys';

export const NavigationsConstants: Readonly<INavigationsConstants> = {
  NavigationModeKey: 'navigationMode',
  QueryParamskey: 'queryParams',
  MaxQueryParamsByUrl: 10,
  defaultHomeNavKey: WlmNavKeys.DistributionNetwork,
};
